import imagesJson from '@designwithfriends/common/images/images.json';

const CDN_IMAGE_ID = /^[cr]:([0-9a-f]{64})$/;
/** What `catalogImageUrl` returns for an id that is not a CDN image id: a transparent pixel, so bad data shows nothing. */
const EMPTY_IMAGE_URL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/** A catalog image from the image CDN, at the smallest rendered size whose longest edge is at least `px`. */
export const catalogImageUrl = (imageId, px) => {
    const hash = CDN_IMAGE_ID.exec(imageId)?.[1];
    if (!hash) return EMPTY_IMAGE_URL;
    const ladder = imagesJson.ladders.catalog;
    const size = ladder.find((s) => s >= px) ?? ladder[ladder.length - 1];
    return `${imagesJson.baseUrl}/c/${hash}/${size}.webp`;
};
